import { loadable } from '@shared/core/loadableFromNamedExport';

export const LazyRegistrationGuest = loadable(() => import(/* webpackChunkName: "content/registration/guest" */ '.'));
